import {EditorSelection} from '@codemirror/state';

import {isCursorInInlineSpace, isInlineSpace, isSingleCursor, selectedText} from '../state.js';
import {selectionBreaksParagraph} from "./format.js";
import {link, linkMeasure} from '../markdown.js';
import {trimmedRangeText} from './ranges.js';
import {quotePadding} from "./padding.js";
import {simplePut} from './changes.js';
import {blank} from "./trim.js";

export function addLink(hrefPlaceholder) {
  return ({state, dispatch}) => {
    if (!canAddLink({state})) {
      return;
    }
    const text = textOrPlaceholder(state, 'link');
    dispatch({
      ...insertMeasured(state, text, linkMeasure(text.trim(), encodeURI(hrefPlaceholder))),
      userEvent: "input.addLink",
    });
  };
}

export function canAddLink({state}) {
  return isInlineSpace(state) && !selectionBreaksParagraph(state);
}

function textOrPlaceholder(state, placeholder) {
  if (isSingleCursor(state)) {
    return placeholder;
  }
  const text = selectedText(state);
  if (blank(text)) {
    return placeholder + text;
  }
  return text;
}

function insertMeasured(state, title, link) {
  return state.changeByRange(range => {
    const {from, to} = trimmedRangeText(title, range);
    const padding = quotePadding(state, from);
    return {
      changes: {from, to, insert: padding + link.markdown},
      range: EditorSelection.range(from + padding.length + link.hrefStart, from + padding.length + link.hrefEnd)
    };
  });
}

export function insertLink(title, href) {
  return ({state, dispatch}) => {
    if (isCursorInInlineSpace(state)) {
      simplePut(state, dispatch, link(title, href));
    }
  };
}
